// src/components/properties/property-view/property-detail-drawer/types.ts

import type { Asset, PhotosetWithAssets } from '@/types/asset.types';
import type { PropertyTable } from '../metadata/propertyConfig';

/** Opaque hero state forwarded from PropertyDetailDrawer to HeroCarousel. */
export interface HeroSource {
  logoUrl: string | null;
  photoset: PhotosetWithAssets | null;
  isPhotosetLoading: boolean;
}

/**
 * Cache-key selection helpers for asset URLs. Existing AssetsImageCard uses
 * `300w` and `830w` (see src/components/property-assets-management/property-asset-view/asset-images/AssetsImageCard.tsx:60).
 * Match those keys for consistency.
 */
export const HERO_CACHE_KEY = '830w' as const;
export const THUMB_CACHE_KEY = '300w' as const;

export const selectHeroUrl = (asset: Asset | undefined): string | null => {
  if (!asset) return null;
  return asset.caches?.[HERO_CACHE_KEY] ?? asset.url ?? null;
};

export const selectThumbUrl = (asset: Asset | undefined): string | null => {
  if (!asset) return null;
  return asset.caches?.[THUMB_CACHE_KEY] ?? asset.caches?.[HERO_CACHE_KEY] ?? asset.url ?? null;
};

export interface PropertyDetailDrawerProps {
  property: PropertyTable | null;
  onOpenChange: (open: boolean) => void;
  onAddToCart: (item: PropertyTable) => void;
  isAddingToCart?: boolean;
  /** True when the open property is already in the cart. */
  isInCart?: boolean;
}
